const CustomerFreelancerLink = {
    title: "Freelancer Link",
    list_title: "Freelancer Links",
    add_title: "Link Freelancer",
    details_title: "Freelancer Link Details",
    filter_title: "Freelancer Link Filter",
    view_details: "View Details",

    user_code: "Freelancer Code",
    link_type: "Link Type",
    category: "Category",
    sub_category: "Sub Category",
    product: "Product",
    linked_to: "Linked To",
    status: "Status",
    created_at: "Created At",

    link_type_category: "Category",
    link_type_subcategory: "Sub Category",
    link_type_product: "Product",

    freelancer_info: "Freelancer Information",
    link_info: "Link Information",
    no_data: "No link record found.",
}

export default CustomerFreelancerLink;
